import './RestaurantsSmallBanner.css';
import React, { memo, useState } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import RouterLink from '../atoms/RouterLink';
import { isNil } from '../../utils/IsNil';
import { ReactComponent as IconChevronDown } from "../../resources/icons/IconChevronDown.svg";
const RestaurantsSmallBanner = /*#__PURE__*/memo(_ref => {
  let {
    fields
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = useState(true);
  const title = get(fields, 'data.datasource.title.jss.value');
  const text = get(fields, 'data.datasource.text.jss.value');
  const imageSrc = get(fields, 'data.datasource.image.jss.value.src');
  const imageAlt = get(fields, 'data.datasource.image.jss.value.alt');
  const href = get(fields, 'data.datasource.link.jss.value.href');
  const buttonText = getDictionaryItem(get(fields, 'data.moduleDictionary'), 'ButtonText') || '';
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('RestaurantsSmallBanner component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [RestaurantsSmallBanner component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "bannerWrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: imageAlt,
    className: "bannerImage"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cardInfo"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "subTitle"
  }, text), /*#__PURE__*/React.createElement(RouterLink, {
    className: "ctaButton",
    href: href,
    linktype: "external",
    openInSameTab: true
  }, buttonText, /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })))));
});
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "cexw5qq";
const ltrStyles = "lvrky7c";
const rtlStyles = "rn5doc2";
export default RestaurantsSmallBanner;